import React, { useEffect, useState } from 'react'
import {
    // SelectedRowWarningModal,
    UploadRepresentments,
    UploadRepresentmentsVC3
} from 'components'
import { CaseData } from 'hooks/cb-api'
import {
    alertSnackbarContentProps,
} from 'components/AlertSnackbar'

interface UploadRepresentmentsRouterProps {
    className?: string
    id?: string
    title?: string
    cases: CaseData[]
    caseIds: number[]
    openModal: boolean
    clientId?: number
    toggleModal: (
        variant:
            | 'assignUser'
            | 'moveToDnr'
            | 'revertDnr'
            | 'uploadDocuments'
            | 'toggleFlag',
        mode?: 'multiselect' | 'single'
    ) => void
    toggleUploadSuccess?: () => void
    isMultiSelect?: boolean
    rehydrateView?: () => void
    isReupload?: boolean
    comments?: string
    setAlertSnackbarMainProps: (value: alertSnackbarContentProps) => void
    setAlertSnackbarMainOpen: (status: boolean) => void
    unselectAllRows?: () => void
    disableRemedy?: boolean
    fromUploadIcon?: boolean
    rowIndex?: number
    selectSingleRowClearRest?: (index: string) => void
    isRequiredCaseComment?: boolean
    isRequiredFileUpload?: boolean
    showEscalateCheckbox?: boolean
    escalateCheckboxLabel?: string
     handlePostUploadAction?:
        | (() => void)
        | null
    submitBtnText?: string
    showUploadIcon?: boolean
}

interface UploadRepresentmentsRouterState {
    filteredSelectedCases: CaseData[]
    filteredHasRemedyCases: CaseData[]
    totalRemedyCases: number
    totalRegularCases: number
    hasRemedy: boolean
    isMixed: boolean
}

const UploadRepresentmentsRouter = ({
    cases,
    caseIds,
    openModal,
    clientId = 0,
    toggleModal,
    toggleUploadSuccess = () => {},
    isMultiSelect = false,
    rehydrateView,
    isReupload = false,
    comments = '',
    setAlertSnackbarMainProps,
    setAlertSnackbarMainOpen,
    unselectAllRows = () => {},
    disableRemedy = false,
    fromUploadIcon = false,
    rowIndex = 0,
    selectSingleRowClearRest = () => {},
    isRequiredCaseComment = false,
    isRequiredFileUpload = false,
    showEscalateCheckbox = false,
    escalateCheckboxLabel = '',
     handlePostUploadAction = null,
    submitBtnText = 'Upload',
    showUploadIcon = true,
    
}: UploadRepresentmentsRouterProps) => {
    const [uploadProps, setUploadProps] = useState<
        UploadRepresentmentsRouterState | undefined
    >(undefined)

    useEffect(() => {
        if (openModal) {
            // For demo purposes, create a proper mock CaseData object that doesn't depend on specific IDs
            const mockCaseData: CaseData = {
                id: 91071844,
                admin_review: null,
                arn: '123456789',
                assigned_user_id: null,
                assigned_user: null,
                auth_no: null,
                case_no: 'CB123456',
                cc_bin: '123456',
                cc_last_four: '1234',
                cc_no: null,
                cc_type: 'Visa',
                cc_type_id: 1,
                cycle: 'First Chargeback',
                cycle_id: 1,
                date_completed: null,
                date_due: '2025-04-01',
                date_post: '2025-03-01',
                date_trans: '2025-02-15',
                descriptor: 'AIRLINE TICKET',
                dispute_amt: '1200.00',
                dispute_currency: 'USD',
                external_uuid: null,
                flag: null,
                is_credit: null,
                is_refund: null,
                mid: '123456789',
                mid_alias: 'AIRLINE-MID',
                mid_id: 12345,
                order_id: null,
                partner_company_id: null,
                processor: 'Processor',
                reason_category: 'Fraud',
                reason_category_id: 1,
                reason_category_description: 'Fraud - Card Not Present',
                reason_code: '10.4',
                reason_code_id: 104,
                status: 'New',
                status_group: 'New',
                status_group_id: 1,
                status_id: 1,
                trans_amt: '1200.00',
                trans_currency: 'USD',
                trans_id: null,
                uuid: null,
                verdict: null,
                verdict_id: null,
                properties: {
                    is_doc_available: true,
                    is_assign_user_enabled: true,
                    is_assign_user_visible: true,
                    is_dnr_enabled: true,
                    is_dnr_visible: true,
                    is_revert_dnr_enabled: false,
                    is_revert_dnr_visible: false,
                    is_upload_representment_enabled: true,
                    is_upload_representment_visible: true,
                    can_remedy: true,
                },
                toggleFlag: () => {},
                doNotRepresent: () => {},
                issuer_docs: [],
                merchant_id: 12345,
                merchant_name: 'Demo Airline',
            }

            // Use the mock cases or actual cases depending on what's available
            const filteredSelectedCases: CaseData[] =
                cases.length > 0 && caseIds.length > 0
                    ? cases.filter((obj) => caseIds.includes(obj.id))
                    : [mockCaseData]

            const filteredHasRemedyCases = filteredSelectedCases.filter(
                (obj) => obj.properties && obj.properties.can_remedy
            )

            if (fromUploadIcon) {
                selectSingleRowClearRest(rowIndex.toString())
            }

            // Always set up the upload props for demo purposes
            setUploadProps({
                filteredSelectedCases: filteredSelectedCases,
                filteredHasRemedyCases: filteredHasRemedyCases,
                totalRegularCases:
                    filteredSelectedCases.length -
                    filteredHasRemedyCases.length,
                totalRemedyCases: filteredHasRemedyCases.length,
                hasRemedy: filteredHasRemedyCases.length > 0,
                isMixed: false, // Set to false to avoid mixed case handling for demo
            })
        }
        return () => setUploadProps(undefined)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal])

    if (!uploadProps) return <></>

    // --- We decided to not go with this, but going to leave it here for now. There's a chance
    // --- that we may have to go back to this idea.
    // if (uploadProps.isMixed) {
    //     return (
    //         <SelectedRowWarningModal
    //             open={uploadProps.isMixed}
    //             toggleOpen={() => setUploadProps(undefined)}
    //             message={`Selection contains ${uploadProps.totalRemedyCases} remedy ready
    //                 and ${uploadProps.totalRegularCases} non-remedy ready cases. Please narrow your selection.`}
    //         />
    //     )
    // }

    if (
        caseIds.length === 1 &&
        !disableRemedy &&
        !uploadProps.isMixed &&
        uploadProps.hasRemedy
    ) {
        return (
            <UploadRepresentmentsVC3
                caseIds={caseIds}
                clientId={clientId}
                openModal={openModal}
                toggleModal={toggleModal}
                rehydrateView={rehydrateView}
                isReupload={isReupload}
                comments={comments}
                isMultiSelect={isMultiSelect}
                setAlertSnackbarMainProps={setAlertSnackbarMainProps}
                setAlertSnackbarMainOpen={setAlertSnackbarMainOpen}
                unselectAllRows={unselectAllRows}
                toggleUploadSuccess={toggleUploadSuccess}
                isVisaCE={uploadProps.hasRemedy}
            />
        )
    }

    return (
        <UploadRepresentments
            caseIds={caseIds}
            clientId={clientId}
            openModal={openModal}
            toggleModal={toggleModal}
            rehydrateView={rehydrateView}
            isReupload={isReupload}
            comments={comments}
            isMultiSelect
            setAlertSnackbarMainProps={setAlertSnackbarMainProps}
            setAlertSnackbarMainOpen={setAlertSnackbarMainOpen}
            unselectAllRows={unselectAllRows}
            toggleUploadSuccess={toggleUploadSuccess}
            isRequiredCaseComment={isRequiredCaseComment}
            isRequiredFileUpload={isRequiredFileUpload}
            showEscalateCheckbox={showEscalateCheckbox}
            escalateCheckboxLabel={escalateCheckboxLabel}
                   handlePostUploadAction={handlePostUploadAction}
            submitBtnText={submitBtnText}
            showUploadIcon={showUploadIcon}
        />
    )
}

export default UploadRepresentmentsRouter